module.exports = __webpack_public_path__ + "static/media/rich_honey_5350.png.fcaad048.webp";